import { useEffect, useState } from 'react';
import isEqual from 'react-fast-compare';
import { useIntl } from 'react-intl';

import { errorHandler } from './utilities';

export const ERROR = 'error';

const initialErrors = {};

const defaultYupOptions = {
  abortEarly: false,
};

// NB: It's _really important_ that these inputs be memoized to prevent infinite re-validation
export const useYupFormValidation = ({ form, schema, options = defaultYupOptions }) => {
  const intl = useIntl();
  const [errors, setErrors] = useState(initialErrors);
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    try {
      setIsValid(schema.isValidSync(form, options));
      schema.validateSync(form, options);
      setErrors(initialErrors);
    } catch (e) {
      setErrors((previousErrors) => {
        const updatedErrors = errorHandler(intl, e);
        return isEqual(previousErrors, updatedErrors) ? previousErrors : updatedErrors;
      });
    }
  }, [form, schema, options, intl]);

  return { errors, isValid };
};
